import { useSyncExternalStore } from 'react'
import { pubSubAppState } from '../../state/pubSub'
import { AppState, APPSTATE } from '../../state/state.app'
export { AppStateType } from '../../constants/enums'

const getAppState =
    <T extends keyof AppState>(key: T) =>
    () =>
        APPSTATE[key]

const getAppSelectorState =
    <T extends keyof AppState, K extends keyof AppState[T]>(
        key: T,
        valueKey: K,
    ) =>
    () =>
        APPSTATE[key][valueKey]

const subAppState =
    <T extends keyof AppState>(key: T) =>
    (callback: () => void) =>
        pubSubAppState.on(key, callback)

export const useAppState = <T extends keyof AppState>(key: T) => {
    const state = useSyncExternalStore<AppState[T]>(
        subAppState(key),
        getAppState(key),
        getAppState(key),
    )

    return state
}
export const useAppStateSelector = <
    T extends keyof AppState,
    K extends keyof AppState[T],
>(
    key: T,
    valueKey: K,
): AppState[T][K] =>
    useSyncExternalStore(
        subAppState(key),
        getAppSelectorState(key, valueKey),
        getAppSelectorState(key, valueKey),
    )
